import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettingsContext } from '@/components/settings';
import { isProductResumeShellPath } from '@/sections/@dashboard/products/Resume/layout/productResumePathUtils';

// Marca que foi a edição do produto que recolheu o menu. Fica no localStorage, junto da preferência
// de layout: se a aba fechar ou recarregar dentro do produto, a volta ao painel ainda reabre o menu.
export const NAV_COLLAPSED_BY_PRODUCT_KEY = 'navCollapsedByProductEdit';

/**
 * Recolhe o menu lateral do painel ao entrar na edição do produto e o devolve ao sair.
 *
 * A edição do produto tem o próprio menu à esquerda: com os dois abertos, sobra pouca largura para
 * o conteúdo. Recolhe só na entrada, para quem reabrir o menu lá dentro não o ver fechar de novo a
 * cada seção, e só reabre o menu que ela mesma recolheu: quem já usa o menu recolhido segue assim.
 */
export default function useCollapseDashboardNav() {
  const { pathname } = useLocation();
  const { themeLayout, onChangeLayout } = useSettingsContext();
  const inProduct = isProductResumeShellPath(pathname);
  const wasInProduct = useRef(null);

  useEffect(() => {
    const entering = inProduct && wasInProduct.current !== true;
    wasInProduct.current = inProduct;

    if (entering && themeLayout === 'vertical') {
      localStorage.setItem(NAV_COLLAPSED_BY_PRODUCT_KEY, '1');
      onChangeLayout({ target: { value: 'mini' } });
      return;
    }

    if (!inProduct && localStorage.getItem(NAV_COLLAPSED_BY_PRODUCT_KEY)) {
      localStorage.removeItem(NAV_COLLAPSED_BY_PRODUCT_KEY);
      if (themeLayout === 'mini') onChangeLayout({ target: { value: 'vertical' } });
    }
    // Só a troca de rota decide: mudar o layout à mão dentro do produto não dispara nada.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inProduct]);
}
